import React from "react";
import { useEffect } from "react";
import Footer from "../components/footer";
import NavbarHome from "../components/navbar-home";
import GaleryFullContent from "../pages/Galerys/galery-full-content";
import GaleryFullJumbotron from "../pages/Galerys/galery-full-jumbotron";

export default function GaleryFull() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <NavbarHome />
      <GaleryFullJumbotron />
      <GaleryFullContent />
      <Footer />
    </>
  );
}
